import { Chip, Tooltip } from "@mui/material";
import { Box } from "@mui/system";

interface Tag {
  id: string;
  name: string;
}

interface TagsDisplayProps {
  tags: Tag[];
}

/**
 * Display a list of tags as a flexbox of chips.
 */
export function TagsDisplay({ tags }: TagsDisplayProps) {
  if (!tags || tags.length === 0) return null;
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {tags.map((tag) => (
        <Tooltip title={tag.name} key={tag.id}>
          <Chip
            label={tag.name}
            size="small"
            variant="outlined"
            sx={{
              height: 20,
              fontSize: "0.75rem",
              "& .MuiChip-label": {
                px: 1,
              },
            }}
          />
        </Tooltip>
      ))}
    </Box>
  );
}
